import $axios from "@/helpers/axios-helper";
import { service_names } from "@/constants/Services";

const state = () => ({
  currentChild: null,
  accChildren: []
});

const mutations = {
  setDataCurrentChild(state, info) {
    state.currentChild = info;
  },

  setAccChildren(state, accList) {
    state.accChildren = [...accList];
  }
};

const actions = {
  async setDefaultChildAccounts(context, familyId) {
    try {
      const accList = await $axios
        .get(`${service_names.user}/families/${familyId}/children`)
        .then(resp => {
          return resp?.data || [];
        });

      context.commit("setAccChildren", accList);
      context.commit("setDataCurrentChild", accList[0]);
    } catch (error) {}
  },

  setCurrentChild(context, selectedChildAcc) {
    context.commit("setDataCurrentChild", selectedChildAcc);
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
